// NOTE:
// - V2 is the current/primary version used in the app.
// - V1 is provided for backward compatibility / future use.
// - Default exports (without version suffix) point to V2 to avoid breaking
//   existing imports. When wiring V1, import the *_V1 named exports.

export const SECTION_1_TABLE_NAMES_V1 = {
  IDENT_INFO: 'IDENT_INFO',
  RELATED_PERSONS: 'RELATED_PERSONS',
  FUND_INFO: 'FUND_INFO',
  MASTER_FEEDER_ARRANGEMENT: 'MASTER_FEEDER_ARRANGEMENT',
  PARALLEL_FUNDS: 'PARALLEL_FUNDS',
  PARALLEL_FUND_DETAILS: 'PARALLEL_FUND_DETAILS',
  GROSS_ASSET: 'GROSS_ASSET',
  NET_ASSET: 'NET_ASSET',
  EQUITY_VALUE_OTHER_FUNDS: 'EQUITY_VALUE_OTHER_FUNDS',
  PARALLEL_MANAGED_ACCOUNTS: 'PARALLEL_MANAGED_ACCOUNTS',
  BORROWINGS_AND_OTHER_CREDITORS: 'BORROWINGS_AND_OTHER_CREDITORS',
  OUTSTANDING_DERIVATIVES: 'OUTSTANDING_DERIVATIVES',
  FUND_ASSETS_AND_LIABILITIES_VALUE: 'FUND_ASSETS_AND_LIABILITIES_VALUE',
  BENEFICIALLY_OWNED_EQUITY_BY_TOP5_OWNERS: 'BENEFICIALLY_OWNED_EQUITY_BY_TOP5_OWNERS',
  BENEFICIALLY_OWNED_EQUITY_INVESTORS: 'BENEFICIALLY_OWNED_EQUITY_INVESTORS',
  GROSS_NET_PERFORMANCE: 'GROSS_NET_PERFORMANCE',
  STRATEGY_TYPE: 'STRATEGY_TYPE',
  STRATEGY_HIGH_FREQUENCY: 'STRATEGY_HIGH_FREQUENCY',
  TRADING_AND_CLEARING: 'TRADING_AND_CLEARING',
  STRATEGY_TYPE_NET_ASSET_VALUE_CAPITAL_ITEM: 'STRATEGY_TYPE_NET_ASSET_VALUE_CAPITAL_ITEM',
  COUNTERPARTIES_DOLLAR: 'COUNTERPARTIES_DOLLAR',
  REPRESENTATIVE_SIGNATURE: 'REPRESENTATIVE_SIGNATURE',
  RELATED_PERSONS_SIGNATURE: 'RELATED_PERSONS_SIGNATURE',
  AGGREGATED_ASSETS: 'AGGREGATED_ASSETS',
  EXPLANATION: 'EXPLANATION',
  COUNTERPARTIES_PERCENT: 'COUNTERPARTIES_PERCENT',
  FILING_TYPE: 'FILING_TYPE',
  AIFM_FILING_TYPE: 'AIFM_FILING_TYPE',
  OTHER_TRANSACTION_PERCENT: 'OTHER_TRANSACTION_PERCENT',
  FUND_IDENTIFYING_INFORMATION_Q18: 'FUND_IDENTIFYING_INFORMATION_Q18'
};

export const SECTION_2_TABLE_NAMES_V1 = {
  HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE: 'HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE',
  HEDGE_FUND_EXPOSURE_TRADING: 'HEDGE_FUND_EXPOSURE_TRADING',
  GEOGRAPHICAL_BREAKDOWN_BY_REGION: 'GEOGRAPHICAL_BREAKDOWN_BY_REGION',
  GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY: 'GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY',
  BASE_CURRENCY_INFORMATION: 'BASE_CURRENCY_INFORMATION',
  TURNOVER: 'TURNOVER',
  LIQUIDITY: 'LIQUIDITY',
  UNENCUMBERED_CASH: 'UNENCUMBERED_CASH',
  HEDGE_FUND_POSITIONS: 'HEDGE_FUND_POSITIONS',
  HEDGE_FUND_COLLATERAL_Q36: 'HEDGE_FUND_COLLATERAL_Q36',
  HEDGE_FUND_COLLATERAL_Q37: 'HEDGE_FUND_COLLATERAL_Q37',
  REHYPOTHECATED_PERCENTAGE: 'REHYPOTHECATED_PERCENTAGE',
  CLEAR_TRANSACTIONS_THROUGH_CCP: 'CLEAR_TRANSACTIONS_THROUGH_CCP',
  VAR_CALCULATED_REGULARLY: 'VAR_CALCULATED_REGULARLY',
  RISK_VAR_CALCULATED: 'RISK_VAR_CALCULATED',
  RISK_VAR_METRIC: 'RISK_VAR_METRIC',
  FINANCING_BORROWING_UNSECURED: 'FINANCING_BORROWING_UNSECURED',
  FINANCING_BORROWING_SECURED: 'FINANCING_BORROWING_SECURED',
  DERIVATIVE_POSITIONS: 'DERIVATIVE_POSITIONS',
  CCP_COLLATERAL: 'CCP_COLLATERAL',
  TOTAL_FINANCING: 'TOTAL_FINANCING',
  TOTAL_FINANCING_IN_DAYS: 'TOTAL_FINANCING_IN_DAYS',
  CREDITORS: 'CREDITORS',
  INVESTOR_INFORMATION: 'INVESTOR_INFORMATION',
  INVESTOR_WITHDRAWAL_REDEMPTION: 'INVESTOR_WITHDRAWAL_REDEMPTION',
  INVESTOR_LIQUIDITY_DAYS: 'INVESTOR_LIQUIDITY_DAYS',
  OPEN_POSITIONS: 'OPEN_POSITIONS',
  RISK_METRICS_BY_MARKET_FACTORS: 'RISK_METRICS_BY_MARKET_FACTORS',
  FINANCING_BORROWING_SECURED_1: 'FINANCING_BORROWING_SECURED_1',
  FINANCING_BORROWING_SECURED_2: 'FINANCING_BORROWING_SECURED_2',
  FINANCING_BORROWING_SECURED_3: 'FINANCING_BORROWING_SECURED_3',
  FUND_IDENTIFYING_INFORMATION_Q29: 'FUND_IDENTIFYING_INFORMATION_Q29',
  //version 2
  QUALIFYING_HEDGE_FUND_INFO: 'QUALIFYING_HEDGE_FUND_INFO',
  ASSET_EXPOSURE1: 'ASSET_EXPOSURE1',
  ASSET_EXPOSURE2: 'ASSET_EXPOSURE2',
  ASSET_ADJUSTED_EXPOSURE1: 'ASSET_ADJUSTED_EXPOSURE1',
  ASSET_ADJUSTED_EXPOSURE2: 'ASSET_ADJUSTED_EXPOSURE2',
  ASSET_EXPOSURE_INTEREST_RATE_RISK: 'ASSET_EXPOSURE_INTEREST_RATE_RISK',
  CURRENCY_EXPOSURE: 'CURRENCY_EXPOSURE',
  CURRENCY_EXPOSURE_5_PERCENT_OR_1_BILLION: 'CURRENCY_EXPOSURE_5_PERCENT_OR_1_BILLION',
  COUNTRY_EXPOSURE_5_PERCENT_OR_1_BILLION: 'COUNTRY_EXPOSURE_5_PERCENT_OR_1_BILLION',
  INDUSTRY_EXPOSURE_5_PERCENT_OR_1_BILLION: 'INDUSTRY_EXPOSURE_5_PERCENT_OR_1_BILLION',
  NETTED_EXPOSURE_FOR_REFERENCE_ASSETS: 'NETTED_EXPOSURE_FOR_REFERENCE_ASSETS',
  CCP_OR_THIRD_PARTY_EXPOSURE: 'CCP_OR_THIRD_PARTY_EXPOSURE',
  RISK_METRICS_AND_PERFORMANCE: 'RISK_METRICS_AND_PERFORMANCE',
  LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH1: 'LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH1',
  LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH2: 'LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH2',
  LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH3: 'LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH3',
  PERFORMANCE_INVESTMENT_STRATEGY_ITEM: 'PERFORMANCE_INVESTMENT_STRATEGY_ITEM',
  FINANCING_LIQUIDITY: 'FINANCING_LIQUIDITY',
  SIDE_POCKET: 'SIDE_POCKET',
  INVESTOR_LIQUIDITY: 'INVESTOR_LIQUIDITY',
  CHANGE_EFFECT_FOR_MARKET_FACTORS: 'CHANGE_EFFECT_FOR_MARKET_FACTORS',
  VAR_ITEM: 'VAR_ITEM'
};

export const SECTION_3_TABLE_NAMES_V1 = {
  LIQUIDITY_FUND_INFO: 'LIQUIDITY_FUND_INFO',
  USE_AMORTIZED_COST_METHOD: 'USE_AMORTIZED_COST_METHOD',
  USE_PENNY_ROUNDING_METHOD: 'USE_PENNY_ROUNDING_METHOD',
  LIQUIDITY_FUND_ASSETS: 'LIQUIDITY_FUND_ASSETS',
  LIQUIDITY_FUND_FINANCING: 'LIQUIDITY_FUND_FINANCING',
  BORROWING_DETAIL: 'BORROWING_DETAIL',
  STABLE_PRICE: 'STABLE_PRICE',
  INVESTOR_OUTSTANDING_SHARES_OF_STOCK: 'INVESTOR_OUTSTANDING_SHARES_OF_STOCK',
  BENEFICIALLY_OWNED_5_PERCENT_EQUITY_BY_INVESTORS:
    'BENEFICIALLY_OWNED_5_PERCENT_EQUITY_BY_INVESTORS',
  SECURITIES_LENDING_COLLATERAL: 'SECURITIES_LENDING_COLLATERAL',
  WITHDRAWAL_REDEMPTION_RESTRICTIONS: 'WITHDRAWAL_REDEMPTION_RESTRICTIONS',
  INVESTOR_LIQUIDITY: 'INVESTOR_LIQUIDITY',
  PORTFOLIO: 'PORTFOLIO',
  MONEY_MARKET_FUND: 'MONEY_MARKET_FUND',
  COMPLY_RULE_2A7_POLICY: 'COMPLY_RULE_2A7_POLICY'
};

export const SECTION_4_TABLE_NAMES_V1 = {
  PRIVATE_EQUITY: 'PRIVATE_EQUITY',
  INVESTMENT_STRATEGY: 'INVESTMENT_STRATEGY',
  INVESTMENT_BY_COUNTRY: 'INVESTMENT_BY_COUNTRY',
  BORROWING_OTHER_CASH_FINANCING: 'BORROWING_OTHER_CASH_FINANCING',
  GUARANTEE_OBLIGATIONS1: 'GUARANTEE_OBLIGATIONS1',
  GUARANTEE_OBLIGATIONS2: 'GUARANTEE_OBLIGATIONS2',
  GUARANTEE_OBLIGATIONS3: 'GUARANTEE_OBLIGATIONS3',
  GUARANTEE_OBLIGATIONS4: 'GUARANTEE_OBLIGATIONS4',
  GUARANTEE_OBLIGATIONS5: 'GUARANTEE_OBLIGATIONS5',
  GUARANTEE_OBLIGATIONS6: 'GUARANTEE_OBLIGATIONS6',
  GUARANTEE_OBLIGATIONS7: 'GUARANTEE_OBLIGATIONS7',
  DEFAULT_EVENT: 'DEFAULT_EVENT',
  NATURE_OF_DEFAULT: 'NATURE_OF_DEFAULT',
  BRIDGE_LOAN: 'BRIDGE_LOAN',
  BRIDGE_LOAN_PERSONS: 'BRIDGE_LOAN_PERSONS',
  BORROWINGS_BY_CREDITOR_TYPE: 'BORROWINGS_BY_CREDITOR_TYPE',
  FINANCING_LOANS: 'FINANCING_LOANS',
  BRIDGE_LOAN_PERSONS_IS_FINANCIAL_INDUSTRY: 'BRIDGE_LOAN_PERSONS_IS_FINANCIAL_INDUSTRY',
  CONTROL_PORTFOLIO_COMPANIES: 'CONTROL_PORTFOLIO_COMPANIES',
  PORTFOLIO_COMPANIES_BY_INDUSTRY: 'PORTFOLIO_COMPANIES_BY_INDUSTRY',
  INVESTED_AMOUNT: 'INVESTED_AMOUNT',
  GEOGRAPHICAL_BREAKDOWN_BY_REGION: 'GEOGRAPHICAL_BREAKDOWN_BY_REGION',
  GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY: 'GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY'
};
